module.exports = __webpack_public_path__ + "img/icon-conf-active.08e01839.svg";